// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  position: relative;
  top: 50%;
  margin: -20px auto 0;
}
.loader::after, .loader::before {
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.loader.primary {
  box-shadow: 0 25px 0 var(--dnest-core-loader-circles-primary-color, var(--dnest-core-loader-circles-color));
  animation: loader-primary 0.8s ease-in-out alternate infinite;
  animation-delay: 0.32s;
}
.loader.primary::after, .loader.primary::before {
  box-shadow: 0 25px 0 var(--dnest-core-loader-circles-primary-color, var(--dnest-core-loader-circles-color));
  animation: loader-primary 0.8s ease-in-out alternate infinite;
}
.loader.primary::before {
  left: var(--dnest-core-loader-circles-primary-space, var(--dnest-core-loader-circles-space));
  animation-delay: 0.48s;
}
.loader.primary::after {
  right: var(--dnest-core-loader-circles-primary-space, var(--dnest-core-loader-circles-space));
  animation-delay: 0.16s;
}
@keyframes loader-primary {
  0% {
    box-shadow: 0 20px 0 var(--dnest-core-loader-circles-primary-color, var(--dnest-core-loader-circles-color));
  }
  100% {
    box-shadow: 0 10px 0 var(--dnest-core-loader-circles-primary-color, var(--dnest-core-loader-circles-color));
  }
}
.loader.secondary {
  box-shadow: 0 25px 0 var(--dnest-core-loader-circles-secondary-color, var(--dnest-core-loader-circles-color));
  animation: loader-secondary 0.8s ease-in-out alternate infinite;
  animation-delay: 0.32s;
}
.loader.secondary::after, .loader.secondary::before {
  box-shadow: 0 25px 0 var(--dnest-core-loader-circles-secondary-color, var(--dnest-core-loader-circles-color));
  animation: loader-secondary 0.8s ease-in-out alternate infinite;
}
.loader.secondary::before {
  left: var(--dnest-core-loader-circles-secondary-space, var(--dnest-core-loader-circles-space));
  animation-delay: 0.48s;
}
.loader.secondary::after {
  right: var(--dnest-core-loader-circles-secondary-space, var(--dnest-core-loader-circles-space));
  animation-delay: 0.16s;
}
@keyframes loader-secondary {
  0% {
    box-shadow: 0 20px 0 var(--dnest-core-loader-circles-secondary-color, var(--dnest-core-loader-circles-color));
  }
  100% {
    box-shadow: 0 10px 0 var(--dnest-core-loader-circles-secondary-color, var(--dnest-core-loader-circles-color));
  }
}
.loader.tertiary {
  box-shadow: 0 25px 0 var(--dnest-core-loader-circles-tertiary-color, var(--dnest-core-loader-circles-color));
  animation: loader-tertiary 0.8s ease-in-out alternate infinite;
  animation-delay: 0.32s;
}
.loader.tertiary::after, .loader.tertiary::before {
  box-shadow: 0 25px 0 var(--dnest-core-loader-circles-tertiary-color, var(--dnest-core-loader-circles-color));
  animation: loader-tertiary 0.8s ease-in-out alternate infinite;
}
.loader.tertiary::before {
  left: var(--dnest-core-loader-circles-tertiary-space, var(--dnest-core-loader-circles-space));
  animation-delay: 0.48s;
}
.loader.tertiary::after {
  right: var(--dnest-core-loader-circles-tertiary-space, var(--dnest-core-loader-circles-space));
  animation-delay: 0.16s;
}
@keyframes loader-tertiary {
  0% {
    box-shadow: 0 20px 0 var(--dnest-core-loader-circles-tertiary-color, var(--dnest-core-loader-circles-color));
  }
  100% {
    box-shadow: 0 10px 0 var(--dnest-core-loader-circles-tertiary-color, var(--dnest-core-loader-circles-color));
  }
}
.loader.quaternary {
  box-shadow: 0 25px 0 var(--dnest-core-loader-circles-quaternary-color, var(--dnest-core-loader-circles-color));
  animation: loader-quaternary 0.8s ease-in-out alternate infinite;
  animation-delay: 0.32s;
}
.loader.quaternary::after, .loader.quaternary::before {
  box-shadow: 0 25px 0 var(--dnest-core-loader-circles-quaternary-color, var(--dnest-core-loader-circles-color));
  animation: loader-quaternary 0.8s ease-in-out alternate infinite;
}
.loader.quaternary::before {
  left: var(--dnest-core-loader-circles-quaternary-space, var(--dnest-core-loader-circles-space));
  animation-delay: 0.48s;
}
.loader.quaternary::after {
  right: var(--dnest-core-loader-circles-quaternary-space, var(--dnest-core-loader-circles-space));
  animation-delay: 0.16s;
}
@keyframes loader-quaternary {
  0% {
    box-shadow: 0 20px 0 var(--dnest-core-loader-circles-quaternary-color, var(--dnest-core-loader-circles-color));
  }
  100% {
    box-shadow: 0 10px 0 var(--dnest-core-loader-circles-quaternary-color, var(--dnest-core-loader-circles-color));
  }
}
.loader.quinary {
  box-shadow: 0 25px 0 var(--dnest-core-loader-circles-quinary-color, var(--dnest-core-loader-circles-color));
  animation: loader-quinary 0.8s ease-in-out alternate infinite;
  animation-delay: 0.32s;
}
.loader.quinary::after, .loader.quinary::before {
  box-shadow: 0 25px 0 var(--dnest-core-loader-circles-quinary-color, var(--dnest-core-loader-circles-color));
  animation: loader-quinary 0.8s ease-in-out alternate infinite;
}
.loader.quinary::before {
  left: var(--dnest-core-loader-circles-quinary-space, var(--dnest-core-loader-circles-space));
  animation-delay: 0.48s;
}
.loader.quinary::after {
  right: var(--dnest-core-loader-circles-quinary-space, var(--dnest-core-loader-circles-space));
  animation-delay: 0.16s;
}
@keyframes loader-quinary {
  0% {
    box-shadow: 0 20px 0 var(--dnest-core-loader-circles-quinary-color, var(--dnest-core-loader-circles-color));
  }
  100% {
    box-shadow: 0 10px 0 var(--dnest-core-loader-circles-quinary-color, var(--dnest-core-loader-circles-color));
  }
}
.loader.senary {
  box-shadow: 0 25px 0 var(--dnest-core-loader-circles-senary-color, var(--dnest-core-loader-circles-color));
  animation: loader-senary 0.8s ease-in-out alternate infinite;
  animation-delay: 0.32s;
}
.loader.senary::after, .loader.senary::before {
  box-shadow: 0 25px 0 var(--dnest-core-loader-circles-senary-color, var(--dnest-core-loader-circles-color));
  animation: loader-senary 0.8s ease-in-out alternate infinite;
}
.loader.senary::before {
  left: var(--dnest-core-loader-circles-senary-space, var(--dnest-core-loader-circles-space));
  animation-delay: 0.48s;
}
.loader.senary::after {
  right: var(--dnest-core-loader-circles-senary-space, var(--dnest-core-loader-circles-space));
  animation-delay: 0.16s;
}
@keyframes loader-senary {
  0% {
    box-shadow: 0 20px 0 var(--dnest-core-loader-circles-senary-color, var(--dnest-core-loader-circles-color));
  }
  100% {
    box-shadow: 0 10px 0 var(--dnest-core-loader-circles-senary-color, var(--dnest-core-loader-circles-color));
  }
}
.loader.septenary {
  box-shadow: 0 25px 0 var(--dnest-core-loader-circles-septenary-color, var(--dnest-core-loader-circles-color));
  animation: loader-septenary 0.8s ease-in-out alternate infinite;
  animation-delay: 0.32s;
}
.loader.septenary::after, .loader.septenary::before {
  box-shadow: 0 25px 0 var(--dnest-core-loader-circles-septenary-color, var(--dnest-core-loader-circles-color));
  animation: loader-septenary 0.8s ease-in-out alternate infinite;
}
.loader.septenary::before {
  left: var(--dnest-core-loader-circles-septenary-space, var(--dnest-core-loader-circles-space));
  animation-delay: 0.48s;
}
.loader.septenary::after {
  right: var(--dnest-core-loader-circles-septenary-space, var(--dnest-core-loader-circles-space));
  animation-delay: 0.16s;
}
@keyframes loader-septenary {
  0% {
    box-shadow: 0 20px 0 var(--dnest-core-loader-circles-septenary-color, var(--dnest-core-loader-circles-color));
  }
  100% {
    box-shadow: 0 10px 0 var(--dnest-core-loader-circles-septenary-color, var(--dnest-core-loader-circles-color));
  }
}
.loader.octonary {
  box-shadow: 0 25px 0 var(--dnest-core-loader-circles-octonary-color, var(--dnest-core-loader-circles-color));
  animation: loader-octonary 0.8s ease-in-out alternate infinite;
  animation-delay: 0.32s;
}
.loader.octonary::after, .loader.octonary::before {
  box-shadow: 0 25px 0 var(--dnest-core-loader-circles-octonary-color, var(--dnest-core-loader-circles-color));
  animation: loader-octonary 0.8s ease-in-out alternate infinite;
}
.loader.octonary::before {
  left: var(--dnest-core-loader-circles-octonary-space, var(--dnest-core-loader-circles-space));
  animation-delay: 0.48s;
}
.loader.octonary::after {
  right: var(--dnest-core-loader-circles-octonary-space, var(--dnest-core-loader-circles-space));
  animation-delay: 0.16s;
}
@keyframes loader-octonary {
  0% {
    box-shadow: 0 20px 0 var(--dnest-core-loader-circles-octonary-color, var(--dnest-core-loader-circles-color));
  }
  100% {
    box-shadow: 0 10px 0 var(--dnest-core-loader-circles-octonary-color, var(--dnest-core-loader-circles-color));
  }
}
.loader.unactive {
  box-shadow: 0 25px 0 var(--dnest-core-loader-circles-unactive-color, var(--dnest-core-loader-circles-color));
  animation: loader-unactive 0.8s ease-in-out alternate infinite;
  animation-delay: 0.32s;
}
.loader.unactive::after, .loader.unactive::before {
  box-shadow: 0 25px 0 var(--dnest-core-loader-circles-unactive-color, var(--dnest-core-loader-circles-color));
  animation: loader-unactive 0.8s ease-in-out alternate infinite;
}
.loader.unactive::before {
  left: var(--dnest-core-loader-circles-unactive-space, var(--dnest-core-loader-circles-space));
  animation-delay: 0.48s;
}
.loader.unactive::after {
  right: var(--dnest-core-loader-circles-unactive-space, var(--dnest-core-loader-circles-space));
  animation-delay: 0.16s;
}
@keyframes loader-unactive {
  0% {
    box-shadow: 0 20px 0 var(--dnest-core-loader-circles-unactive-color, var(--dnest-core-loader-circles-color));
  }
  100% {
    box-shadow: 0 10px 0 var(--dnest-core-loader-circles-unactive-color, var(--dnest-core-loader-circles-color));
  }
}`, "",{"version":3,"sources":["webpack://./projects/dnest-core-angular/src/lib/components/loader-circles/loader-circles.component.scss","webpack://./projects/dnest-core-angular/src/lib/styles/mixins/_loader-circles.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,oBAAA;AADJ;AAGI;EAEI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAFR;ACZQ;EACI,2GAAA;EACA,6DAAA;EACA,sBAAA;ADcZ;ACZY;EAEI,2GAAA;EACA,6DAAA;ADahB;ACVY;EACI,4FAAA;EACA,sBAAA;ADYhB;ACTY;EACI,6FAAA;EACA,sBAAA;ADWhB;ACPQ;EACI;IACI,2GAAA;EDSd;ECNU;IACI,2GAAA;EDQd;AACF;ACrCQ;EACI,6GAAA;EACA,+DAAA;EACA,sBAAA;ADuCZ;ACrCY;EAEI,6GAAA;EACA,+DAAA;ADsChB;ACnCY;EACI,8FAAA;EACA,sBAAA;ADqChB;AClCY;EACI,+FAAA;EACA,sBAAA;ADoChB;AChCQ;EACI;IACI,6GAAA;EDkCd;EC/BU;IACI,6GAAA;EDiCd;AACF;AC9DQ;EACI,4GAAA;EACA,8DAAA;EACA,sBAAA;ADgEZ;AC9DY;EAEI,4GAAA;EACA,8DAAA;AD+DhB;AC5DY;EACI,6FAAA;EACA,sBAAA;AD8DhB;AC3DY;EACI,8FAAA;EACA,sBAAA;AD6DhB;ACzDQ;EACI;IACI,4GAAA;ED2Dd;ECxDU;IACI,4GAAA;ED0Dd;AACF;ACvFQ;EACI,8GAAA;EACA,gEAAA;EACA,sBAAA;ADyFZ;ACvFY;EAEI,8GAAA;EACA,gEAAA;ADwFhB;ACrFY;EACI,+FAAA;EACA,sBAAA;ADuFhB;ACpFY;EACI,gGAAA;EACA,sBAAA;ADsFhB;AClFQ;EACI;IACI,8GAAA;EDoFd;ECjFU;IACI,8GAAA;EDmFd;AACF;AChHQ;EACI,2GAAA;EACA,6DAAA;EACA,sBAAA;ADkHZ;AChHY;EAEI,2GAAA;EACA,6DAAA;ADiHhB;AC9GY;EACI,4FAAA;EACA,sBAAA;ADgHhB;AC7GY;EACI,6FAAA;EACA,sBAAA;AD+GhB;AC3GQ;EACI;IACI,2GAAA;ED6Gd;EC1GU;IACI,2GAAA;ED4Gd;AACF;ACzIQ;EACI,0GAAA;EACA,4DAAA;EACA,sBAAA;AD2IZ;ACzIY;EAEI,0GAAA;EACA,4DAAA;AD0IhB;ACvIY;EACI,2FAAA;EACA,sBAAA;ADyIhB;ACtIY;EACI,4FAAA;EACA,sBAAA;ADwIhB;ACpIQ;EACI;IACI,0GAAA;EDsId;ECnIU;IACI,0GAAA;EDqId;AACF;AClKQ;EACI,6GAAA;EACA,+DAAA;EACA,sBAAA;ADoKZ;AClKY;EAEI,6GAAA;EACA,+DAAA;ADmKhB;AChKY;EACI,8FAAA;EACA,sBAAA;ADkKhB;AC/JY;EACI,+FAAA;EACA,sBAAA;ADiKhB;AC7JQ;EACI;IACI,6GAAA;ED+Jd;EC5JU;IACI,6GAAA;ED8Jd;AACF;AC3LQ;EACI,4GAAA;EACA,8DAAA;EACA,sBAAA;AD6LZ;AC3LY;EAEI,4GAAA;EACA,8DAAA;AD4LhB;ACzLY;EACI,6FAAA;EACA,sBAAA;AD2LhB;ACxLY;EACI,8FAAA;EACA,sBAAA;AD0LhB;ACtLQ;EACI;IACI,4GAAA;EDwLd;ECrLU;IACI,4GAAA;EDuLd;AACF;ACpNQ;EACI,4GAAA;EACA,8DAAA;EACA,sBAAA;ADsNZ;ACpNY;EAEI,4GAAA;EACA,8DAAA;ADqNhB;AClNY;EACI,6FAAA;EACA,sBAAA;ADoNhB;ACjNY;EACI,8FAAA;EACA,sBAAA;ADmNhB;AC/MQ;EACI;IACI,4GAAA;EDiNd;EC9MU;IACI,4GAAA;EDgNd;AACF","sourcesContent":["@import '../../styles/mixins.scss';\n\n.loader {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    position: relative;\n    top: 50%;\n    margin: -20px auto 0;\n\n    &::after,\n    &::before {\n        content: '';\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-radius: 50%;\n    }\n\n    @include generate-themes-styles-loader-circles;\n}","@mixin generate-themes-styles-loader-circles {\n    @each $theme in $themes {\n        &.#{$theme} {\n            box-shadow: 0 25px 0 var(--dnest-core-loader-circles-#{$theme}-color, var(--dnest-core-loader-circles-color));\n            animation: loader-#{$theme} .8s ease-in-out alternate infinite;\n            animation-delay: .32s;\n\n            &::after,\n            &::before {\n                box-shadow: 0 25px 0 var(--dnest-core-loader-circles-#{$theme}-color, var(--dnest-core-loader-circles-color));\n                animation: loader-#{$theme} .8s ease-in-out alternate infinite;\n            }\n        \n            &::before {\n                left: var(--dnest-core-loader-circles-#{$theme}-space, var(--dnest-core-loader-circles-space));\n                animation-delay: .48s;\n            }\n        \n            &::after {\n                right: var(--dnest-core-loader-circles-#{$theme}-space, var(--dnest-core-loader-circles-space));\n                animation-delay: .16s;\n            }\n        }\n        \n        @keyframes loader-#{$theme} {\n            0% {\n                box-shadow: 0 20px 0 var(--dnest-core-loader-circles-#{$theme}-color, var(--dnest-core-loader-circles-color));\n            }\n        \n            100% {\n                box-shadow: 0 10px 0 var(--dnest-core-loader-circles-#{$theme}-color, var(--dnest-core-loader-circles-color));\n            }\n        }\n    }\n}\n\n@mixin generate-themes-variables-loader-circles {\n    --dnest-core-loader-circles-color: var(--primary);\n    --dnest-core-loader-circles-space: 15px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
